<script>
import Layout from '@layouts/main'

export default {
  metaInfo: {
    title: '404',
    meta: [{ name: 'description', content: '404' }],
  },
  components: { Layout },
  props: {
    resource: {
      type: String,
      default: '',
    },
  },
}
</script>

<template>
  <Layout>
    <v-container fluid grid-list-md ma-0>
      <h1 :class="$style.title">
        404
        <template v-if="resource">
          {{ resource }}
        </template>
        Not Found
      </h1>
    </v-container>
  </Layout>
</template>

<style lang="scss" module>
.title {
  text-align: center;
}
</style>
